import { RequestHeader } from "../../WebServiceManager/RequestHeader";
import { RequestBody } from "../../WebServiceManager/RequestBody";

import LOCAL_KEYS, {
  parseLocalStorageJSON,
} from "../../../helpers/Localstorage";


export default class TimeOffRequestBody {
  getTimeOffRequestsRequest = (method) => {
    const header = new RequestHeader();
    const request = new RequestBody(
      method,
      header.applicationJson(parseLocalStorageJSON(LOCAL_KEYS.ACCESS_TOKEN)),
    );
    return request;
  };

  approveTimeOffRequestRequest = (method, obj) => {
    const header = new RequestHeader();
    const request = new RequestBody(
      method,header.applicationJson(parseLocalStorageJSON(LOCAL_KEYS.ACCESS_TOKEN)),
      obj
    
    );
    return request;
  };

  getTimeOffByIdRequest = (method) => {
    const header = new RequestHeader();
    const request = new RequestBody(
      method,
      header.applicationJson(parseLocalStorageJSON(LOCAL_KEYS.ACCESS_TOKEN)),
    );
    return request;
  };

  updateTimeOffRequestRequest = (method, obj) => {
    const header = new RequestHeader();
    const request = new RequestBody(
      method,
      header.applicationJson(parseLocalStorageJSON(LOCAL_KEYS.ACCESS_TOKEN)),
      obj
    );
    return request;
  };
  createTimeOffRequestRequest = (method, obj) => {
    const header = new RequestHeader();
    const request = new RequestBody(
      method,
      header.applicationJson(parseLocalStorageJSON(LOCAL_KEYS.ACCESS_TOKEN)),
      obj
    );
    return request;
  };

  
}

